import React, { useEffect, useState } from "react";
import { obterFacetas } from "../services/api";

// Cidades e setores vinham na ordem da consulta. Sao listas longas e de VALOR SIMPLES (string), entao a
// ordenacao e direta — ver ordAlfa no AdminPage para o porque do localeCompare pt-BR.
function ordAlfa(lista) {
  return [...(lista || [])].sort((a, b) =>
    String(a ?? "").localeCompare(String(b ?? ""), "pt-BR", { sensitivity: "base" }));
}

// Status alinhados ao enum StatusDenuncia do backend.
const STATUS = [
  { v: null, t: "Todos" },
  { v: 0, t: "Sem resposta" },
  { v: 1, t: "Respondida" },
  { v: 2, t: "Contestada" },
  { v: 3, t: "Resolvida" },
  { v: 5, t: "Resolvida parcialmente" }, // StatusDenuncia.ResolvidaParcialmente — faltava no filtro
  { v: 4, t: "Não resolvida" },
];

// Natureza do relato (alinhado ao enum NaturezaRelato): reclamação / elogio / neutro.
const NATUREZAS = [
  { v: null, t: "Todos os relatos" },
  { v: 0, t: "😞 Reclamações" },
  { v: 1, t: "😊 Elogios" },
  { v: 2, t: "😐 Neutros" },
];

export default function Filters({ onChange, valores = {} }) {
  const [facetas, setFacetas] = useState({ setores: [], cidades: [] });

  useEffect(() => {
    obterFacetas()
      .then((f) => setFacetas({ setores: f?.setores ?? [], cidades: f?.cidades ?? [] }))
      .catch(() => setFacetas({ setores: [], cidades: [] }));
  }, []);

  const selectCls =
    "mt-1 w-full rounded-xl border border-gray-200 px-3 py-2 outline-none focus:ring-2 focus:ring-primary";

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
      <h4 className="text-base font-semibold text-gray-900">Filtros</h4>

      <div className="mt-4 space-y-3">
        <div>
          <label className="text-sm text-gray-600">Tipo de relato</label>
          <select
            aria-label="Filtrar por tipo de relato"
            value={valores.natureza ?? ""}
            onChange={(e) => onChange?.({ natureza: e.target.value === "" ? null : Number(e.target.value) })}
            className={selectCls}
          >
            {NATUREZAS.map((n) => (
              <option key={String(n.v)} value={n.v ?? ""}>{n.t}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="text-sm text-gray-600">Status</label>
          <select
            aria-label="Filtrar por status"
            value={valores.status ?? ""}
            onChange={(e) => onChange?.({ status: e.target.value === "" ? null : Number(e.target.value) })}
            className={selectCls}
          >
            {STATUS.map((s) => (
              <option key={String(s.v)} value={s.v ?? ""}>{s.t}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="text-sm text-gray-600">Cidade</label>
          <select
            aria-label="Filtrar por cidade"
            value={valores.cidade || ""}
            onChange={(e) => onChange?.({ cidade: e.target.value || "" })}
            className={selectCls}
          >
            <option value="">Todas</option>
            {ordAlfa(facetas.cidades).map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="text-sm text-gray-600">Setor</label>
          <select
            aria-label="Filtrar por setor"
            value={valores.setor || ""}
            onChange={(e) => onChange?.({ setor: e.target.value || "" })}
            className={selectCls}
          >
            <option value="">Todos</option>
            {ordAlfa(facetas.setores).map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>

        {(valores.status != null || valores.cidade || valores.setor || valores.natureza != null) && (
          <button
            type="button"
            onClick={() => onChange?.({ status: null, cidade: "", setor: "", natureza: null })}
            className="text-sm text-primary hover:underline"
          >
            Limpar filtros
          </button>
        )}
      </div>
    </div>
  );
}
